<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="none">
        <polyline stroke-linecap="round" stroke="#F00036" stroke-width="2" points="2 2 14 14"/>
        <polyline stroke-linecap="round" stroke="#F00036" stroke-width="2" points="14 2 2 14"/>
    </svg>
</template>